import axios from "axios";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
const URL = apiEndpoint || process.env.REACT_APP_DEV_URL;
 

const axiosInstance = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export const configureAxiosInterceptor = (accessToken) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
